export enum errorMessagesNames {
  AcademyInitializationFailed = 'AcademyInitializationFailed',
  AcademyUpdateFailed = 'AcademyUpdateFailed',
  AcademyIntegrationError = 'AcademyIntegrationError',
  AcademyAPICallError = 'AcademyAPICallError',
  AcademySeatLimitExceeded = 'AcademySeatLimitExceeded',
  AcademyUserNotFound = 'AcademyUserNotFound',
  AcademyUserDeactivated = 'AcademyUserDeactivated',
  ApiKeyIsExpired = 'ApiKeyIsExpired',
  AuditFindingModifiedByOthers = 'AuditFindingModifiedByOthers',
  CannotDeleteLastDigitalProperty = 'CannotDeleteLastDigitalProperty',
  CannotMoveScanDomainNotAllowed = 'CannotMoveScanDomainNotAllowed',
  CannotMoveLastDigitalProperty = 'CannotMoveLastDigitalProperty',
  CannotMoveDigitalPropertyWithData = 'CannotMoveDigitalPropertyWithData',
  CannotMoveDigitalPropertyNameCollision = 'CannotMoveDigitalPropertyNameCollision',
  CannotMoveDigitalPropertyKeyCollision = 'CannotMoveDigitalPropertyKeyCollision',
  CannotMoveDigitalPropertyFromInactiveWorkspace = 'CannotMoveDigitalPropertyFromInactiveWorkspace',
  CannotMoveDigitalPropertyToInactiveWorkspace = 'CannotMoveDigitalPropertyToInactiveWorkspace',
  ConfigPropertyNotProvided = 'ConfigPropertyNotProvided',
  CannotDeleteDigitalPropertyWithData = 'CannotDeleteDigitalPropertyWithData',
  CannotCopyEvaluationWithoutScope = 'CannotCopyEvaluationWithoutScope',
  CannotChangeMediumWhenCopying = 'CannotChangeMediumWhenCopying',
  DisplayNameExists = 'DisplayNameExists',
  DigitalPropertyInvalidDomains = 'DigitalPropertyInvalidDomains',
  DigitalPropertyMonitoringInvalidDomains = 'DigitalPropertyMonitoringInvalidDomains',
  DigitalPropertyMonitoringInvalidThreshold = 'DigitalPropertyMonitoringInvalidThreshold',
  DigitalPropertyMonitoringInvalidUserIds = 'DigitalPropertyMonitoringInvalidUserIds',
  DigitalPropertyMonitoringHasDuplicateUserIds = 'DigitalPropertyMonitoringHasDuplicateUserIds',
  DigitalPropertyMonitoringContainsNonPlatformUsers = 'DigitalPropertyMonitoringContainsNonPlatformUsers',
  DigitalPropertyMonitoringInvalidAlertType = 'DigitalPropertyMonitoringInvalidAlertType',
  MonitoringInvalidDomainSitemap = 'MonitoringInvalidDomainSitemap',
  DownloadResourceNotAuthorized = 'DownloadResourceNotAuthorized',
  EmptyFile = 'EmptyFile',
  ErrorUpdatingPageSummary = 'ErrorUpdatingPageSummary',
  ErrorMissingJiraIssueType = 'ErrorMissingJiraIssueType',
  ErrorUpdatingScanSummary = 'ErrorUpdatingScanSummary',
  ErrorScanIsLocked = 'ErrorScanIsLocked',
  ErrorAnalyticsForNonMonitoringScan = 'ErrorAnalyticsForNonMonitoringScan',
  ErrorAuditExecutionFailed = 'ErrorAuditExecutionFailed',
  ErrorApiKeyDuplicateName = 'ErrorApiKeyDuplicateName',
  ErrorApiKeyMaxExceeded = 'ErrorApiKeyMaxExceeded',
  ErrorApiKeyFailedCreateRandom = 'ErrorApiKeyFailedCreateRandom',
  ErrorApiKeyReminderExceedsExpiry = 'ErrorApiKeyReminderExceedsExpiry',
  ErrorCannotRenameSystemTag = 'ErrorCannotRenameSystemTag',
  ErrorCannotDeleteSystemTag = 'ErrorCannotDeleteSystemTag',
  ErrorCannotDeleteTagInUse = 'ErrorCannotDeleteTagInUse',
  ErrorTagNameTooLong = 'ErrorTagNameTooLong',
  ErrorInvalidViewportSize = 'ErrorInvalidViewportSize',
  ErrorCannotAddUserToClosedPrivateWorkspace = 'ErrorCannotAddUserToClosedPrivateWorkspace',
  ErrorAddingUserAsWorkspaceStaffIsForbidden = 'ErrorAddingUserAsWorkspaceStaffIsForbidden',
  ErrorCantRemoveWorkspaceWithUsers = 'ErrorCantRemoveWorkspaceWithUsers',
  ErrorCantRemoveLastTenantWorkspace = 'ErrorCantRemoveLastTenantWorkspace',
  ErrorCantArchiveWorkspaceWithUsers = 'ErrorCantArchiveWorkspaceWithUsers',
  ErrorCantArchiveLastTenantWorkspace = 'ErrorCantArchiveLastTenantWorkspace',
  ErrorCheckUrlFormAuthCredentialsDuplication = 'ErrorCheckUrlFormAuthCredentialsDuplication',
  ErrorCreationFalsePositiveError = 'ErrorCreationFalsePositiveError',
  ErrorDashboardScanReportInvalidStatus = 'ErrorDashboardScanReportInvalidStatus',
  ErrorDeactivatingUser = 'ErrorDeactivatingUser',
  ErrorDeleteRole = 'ErrorDeleteRole',
  ErrorScanUrlNotInLicensedDomains = 'ErrorScanUrlNotInLicensedDomains',
  ErrorUserEmailUnverified = 'ErrorUserEmailUnverified',
  CannotUpdateDigitalPropertyKey = 'CannotUpdateDigitalPropertyKey',
  CannotUpdateMobileBundleId = 'CannotUpdateMobileBundleId',
  InvalidMobileBundleId = 'InvalidMobileBundleId',
  CannotUpdateProjectKey = 'CannotUpdateProjectKey',
  ProjectKeyAlreadyExists = 'ProjectKeyAlreadyExists',
  OwnerNotInWorkspace = 'OwnerNotInWorkspace',
  CannotRemoveActiveUserData = 'CannotRemoveActiveUserData',
  CreateFindingForDisabledRule = 'CreateFindingForDisabledRule',
  InvalidCreateFindingRequest = 'InvalidCreateFindingRequest',
  UpdateFindingForDisabledRule = 'UpdateFindingForDisabledRule',
  DuplicatedDigitalPropertyKey = 'DuplicatedDigitalPropertyKey',
  DuplicatedDigitalPropertyName = 'DuplicatedDigitalPropertyName',
  ErrorDigitalPropertyNotFound = 'ErrorDigitalPropertyNotFound',
  ErrorDigitalPropertyManualAuditNameDuplicated = 'ErrorDigitalPropertyManualAuditNameDuplicated',
  ErrorCommentNotFound = 'ErrorCommentNotFound',
  ErrorDigitalPropertyTypesNotFound = 'ErrorDigitalPropertyTypesNotFound',
  ErrorDocumentClientMustBeWorkspaceUser = 'ErrorDocumentClientMustBeWorkspaceUser',
  ErrorDocumentNotFound = 'ErrorDocumentNotFound',
  ErrorDocumentFileNotFound = 'ErrorDocumentFileNotFound',
  ErrorUrlIsAScannableDocument = 'ErrorUrlIsAScannableDocument',
  ErrorFileExceedsLimit = 'ErrorFileExceedsLimit',
  ErrorScannableDocumentNumberOfFilesExceedsLimit = 'ErrorScannableDocumentNumberOfFilesExceedsLimit',
  ErrorScannableDocumentFileIsRequired = 'ErrorScannableDocumentFileIsRequired',
  ErrorScannableDocumentUnsupportedFileExtension = 'ErrorScannableDocumentUnsupportedFileExtension',
  ErrorScannableDocumentDownloadUnsuccessful = 'ErrorScannableDocumentDownloadUnsuccessful',
  ErrorAuditedDocumentNotFound = 'ErrorAuditedDocumentNotFound',
  ErrorDuplicateRoleName = 'ErrorDuplicateRoleName',
  ErrorDuplicateTag = 'ErrorDuplicateTag',
  ErrorDuplicationCreatingDigitalPropertiesTypes = 'ErrorDuplicationCreatingDigitalPropertiesTypes',
  ErrorExceedScanUrlsSizeLimit = 'ErrorExceedScanUrlsSizeLimit',
  ErrorGettingCountriesList = 'ErrorGettingCountriesList',
  InvalidDigitalPropertyKey = 'InvalidDigitalPropertyKey',
  ErrorGettingUserScanOptions = 'ErrorGettingUserScanOptions',
  ErrorGettingUserWorkspace = 'ErrorGettingUserWorkspace',
  ErrorGettingWorkspace = 'ErrorGettingWorkspace',
  ErrorInvalidApiParameter = 'ErrorInvalidApiParameter',
  ErrorInvalidJSONAuditRuleData = 'ErrorInvalidJSONAuditRuleData',
  ErrorInvalidQueryParam = 'ErrorInvalidQueryParam',
  ErrorJobIndustryDBError = 'ErrorJobIndustryDBError',
  ErrorLoadingScanJobPage = 'ErrorLoadingScanJobPage',
  ErrorLastDigitalPropertyCannotBeArchived = 'ErrorLastDigitalPropertyCannotBeArchived',
  ErrorNonMonitoringScan = 'ErrorNonMonitoringScan',
  ErrorMissingAPIParameter = 'ErrorMissingAPIParameter',
  ErrorMissingAuditToolInDB = 'ErrorMissingAuditToolInDB',
  ErrorMissingReportBuilder = 'ErrorMissingReportBuilder',
  ErrorMissingConfirmEmailToken = 'ErrorMissingConfirmEmailToken',
  ErrorInvalidConfirmEmailToken = 'ErrorInvalidConfirmEmailToken',
  ErrorReservedSystemTagUsedWhereNotAllowed = 'ErrorReservedSystemTagUsedWhereNotAllowed',
  ErrorMultipleAccountSetUpsNotAllowed = `ErrorMultipleAccountSetUpsNotAllowed`,
  ErrorNotAllowedToModifyOtherUsersScanOptions = 'ErrorNotAllowedToModifyOtherUsersScanOptions',
  ErrorProcessingReportDetails = 'ErrorProcessingReportDetails',
  ErrorProcessingScanRequest = 'ErrorProcessingScanRequest',
  ErrorReportNotFound = 'ErrorReportNotFound',
  ErrorCannotRerunCIToolScan = 'ErrorCannotRerunCIToolScan',
  ErrorCompanyNotFound = 'ErrorCompanyNotFound',
  ErrorDecodedTokenUserIdInvalid = 'ErrorDecodedTokenUserIdInvalid',
  ErrorDigitalPropertyArchived = 'ErrorDigitalPropertyArchived',
  ErrorInvalidResetPasswordToken = 'ErrorInvalidResetPasswordToken',
  ErrorIncorrectToolOrVersion = 'ErrorIncorrectToolOrVersion',
  ErrorMissingScanAudit = 'ErrorMissingScanAudit',
  ErrorProjectNotFound = 'ErrorProjectNotFound',
  ErrorTaskNotFound = 'ErrorTaskNotFound',
  ErrorPublicTaskFindingNotFound = 'ErrorPublicTaskFindingNotFound',
  ErrorPublicTaskUpdateEmptyBody = 'ErrorPublicTaskUpdateEmptyBody',
  ErrorPublicTaskPartiallyUpdated = 'ErrorPublicTaskPartiallyUpdated',
  ErrorPublicTaskProjectArchived = 'ErrorPublicTaskProjectArchived',
  ErrorSomeTasksNotFound = 'ErrorSomeTasksNotFound',
  ErrorSomeTasksHaveUnallowedStatus = 'ErrorSomeTasksHaveUnallowedStatus',
  ErrorTaskIsLinked = 'ErrorTaskIsLinked',
  ErrorTaskAlreadyAssignedToSameUser = 'ErrorTaskAlreadyAssignedToSameUser',
  ErrorTaskAlreadyUnassigned = 'ErrorTaskAlreadyUnassigned',
  ErrorDuplicateIssueTrackingConnection = 'ErrorDuplicateIssueTrackingConnection',
  ErrorCannotGetJiraAuthorizeUrl = 'ErrorCannotGetJiraAuthorizeUrl',
  ErrorJiraAuthorizeUrlFailAuthentication = 'ErrorJiraAuthorizeUrlFailAuthentication',
  ErrorJiraInstanceUrlMismatch = 'ErrorJiraInstanceUrlMismatch',
  ErrorCannotCreateJiraIssue = 'ErrorCannotCreateJiraIssue',
  ErrorInvalidIssueTrackingConnectionInstance = 'ErrorInvalidIssueTrackingConnectionInstance',
  ErrorCannotVerifyJiraCode = 'ErrorCannotVerifyJiraCode',
  ErrorIssueTrackingConnectionNotFoundInDb = 'ErrorIssueTrackingConnectionNotFoundInDb',
  ErrorIntegrationInstanceIsNotAuthorized = 'ErrorIntegrationInstanceIsNotAuthorized',
  ErrorCannotGetIssueTrackingProjects = 'ErrorCannotGetIssueTrackingProjects',
  ErrorCannotGetIssueTrackingProject = 'ErrorCannotGetIssueTrackingProject',
  ErrorGithubRepoNotAccessible = 'ErrorGithubRepoNotAccessible',
  ErrorCannotGetGithubProject = 'ErrorCannotGetGithubProject',
  ErrorCannotGetGithubAssignableUsers = 'ErrorCannotGetGithubAssignableUsers',
  ErrorCannotGetGithubMilestones = 'ErrorCannotGetGithubMilestones',
  ErrorCannotGetGithubLabels = 'ErrorCannotGetGithubLabels',
  ErrorMissingGithubProjectId = 'ErrorMissingGithubProjectId',
  ErrorCannotGetGithubIssue = 'ErrorCannotGetGithubIssue',
  ErrorGithubIssueClosed = 'ErrorGithubIssueClosed',
  ErrorCannotGetGitlabIssue = 'ErrorCannotGetGitlabIssue',
  ErrorGitlabIssueClosed = 'ErrorGitlabIssueClosed',
  ErrorCannotGetGithubIssueTypes = 'ErrorCannotGetGithubIssueTypes',
  ErrorCannotGetGithubIssueFields = 'ErrorCannotGetGithubIssueFields',
  ErrorCannotSetGithubIssueFieldValues = 'ErrorCannotSetGithubIssueFieldValues',
  ErrorCannotGetGithubProjectsV2 = 'ErrorCannotGetGithubProjectsV2',
  ErrorCannotGetGithubProjectV2Fields = 'ErrorCannotGetGithubProjectV2Fields',
  ErrorGithubProjectV2NotFoundForRepository = 'ErrorGithubProjectV2NotFoundForRepository',
  ErrorCannotGetJiraIssueTypes = 'ErrorCannotGetJiraIssueTypes',
  ErrorCannotGetIssueTrackingIssueStatuses = 'ErrorCannotGetIssueTrackingIssueStatuses',
  ErrorCannotGetIssueTrackingIssueTypeStatuses = 'ErrorCannotGetIssueTrackingIssueTypeStatuses',
  ErrorCannotGetAsanaIssueTypeStatuses = 'ErrorCannotGetAsanaIssueTypeStatuses',
  ErrorCannotGetAsanaIssueStatuses = 'ErrorCannotGetAsanaIssueStatuses',
  ErrorCannotGetGithubIssueStatuses = 'ErrorCannotGetGithubIssueStatuses',
  ErrorMissingIssueTrackingInstanceOrProject = 'ErrorMissingIssueTrackingInstanceOrProject',
  ErrorMissingPropertiesScanResult = 'ErrorMissingPropertiesScanResult',
  ErrorRetrieveScanDB = 'ErrorRetrieveScanDB',
  ErrorRoleInUse = 'ErrorRoleInUse',
  ErrorWorkspaceClosed = 'ErrorWorkspaceClosed',
  ErrorWorkspaceUserNotFound = 'ErrorWorkspaceUserNotFound',
  ScanOptionNotFound = 'ScanOptionNotFound',
  ErrorScanEmailReports = 'ErrorScanEmailReports',
  ErrorScanJobExecutionFailed = 'ErrorScanJobExecutionFailed',
  ErrorScanJobInvalidMimeType = 'ErrorScanJobInvalidMimeType',
  ErrorScanJobInvalidResponseCode = 'ErrorScanJobInvalidResponseCode',
  ErrorScanMissingAudit = 'ErrorScanMissingAudit',
  ErrorPreScanFlowNotAllowedForTenantPackage = 'ErrorPreScanFlowNotAllowedForTenantPackage',
  ErrorScanMissingContentType = 'ErrorScanMissingContentType',
  ErrorScanPageLimitTooHigh = 'ErrorScanPageLimitTooHigh',
  ErrorScanStatusCode = 'ErrorScanStatusCode',
  ErrorScanTimeout = 'ErrorScanTimeout',
  ErrorAutomatedUserFlowTimeout = 'ErrorAutomatedUserFlowTimeout',
  ErrorScanningJobNotFound = 'ErrorScanningJobNotFound',
  ErrorSystemTag = 'ErrorSystemTag',
  ErrorTagNotFound = 'ErrorTagNotFound',
  ErrorUnsupportedFileType = 'ErrorUnsupportedFileType',
  ErrorUpdatingUserPreferences = 'ErrorUpdatingUserPreferences',
  ErrorUpdateRole = 'ErrorUpdateRole',
  ErrorUpdatingUserProfile = 'ErrorUpdatingUserProfile',
  ErrorUrlNotSubscribed = 'ErrorUrlNotSubscribed',
  ErrorResolvedUrlNotSubscribed = 'ErrorResolvedUrlNotSubscribed',
  ErrorUserDocumentNotFound = 'ErrorUserDocumentNotFound',
  ErrorUserNotFound = 'ErrorUserNotFound',
  ErrorUserNotFoundRetrievingLastUsedWorkspace = 'ErrorUserNotFoundRetrievingLastUsedWorkspace',
  ErrorUserNotFoundRetrievingLastUsedProperty = 'ErrorUserNotFoundRetrievingLastUsedProperty',
  ErrorUserRoleNotFound = 'ErrorUserRoleNotFound',
  ErrorWorkspaceNotFound = 'ErrorWorkspaceNotFound',
  ErrorWorkspaceDuplicateName = 'ErrorWorkspaceDuplicateName',
  ExpectingString = 'ExpectingString',
  ExpectingValidURL = 'ExpectingValidURL',
  ExpectingOneOf = 'ExpectingOneOf',
  ExpectingManyOf = 'ExpectingManyOf',
  CurrentUserMustBeWorkspaceMember = 'CurrentUserMustBeWorkspaceMember',
  FailedToAuthenticateAccessToken = 'FailedToAuthenticateAccessToken',
  FailedToAuthenticateRefreshToken = 'FailedToAuthenticateRefreshToken',
  FilesWithRestrictedUrls = 'FilesWithRestrictedUrls',
  LogInIncorrectUsernameOrPassword = 'LogInIncorrectUsernameOrPassword',
  LogInAccountIsLocked = 'LogInAccountIsLocked',
  ImageValidationFailed = 'ImageValidationFailed',
  InvalidApiKey = 'InvalidApiKey',
  InvalidAuditResults = 'InvalidAuditResults',
  InvalidCurrentPassword = 'InvalidCurrentPassword',
  InvalidIdValue = 'InvalidIdValue',
  InvalidReportFormat = 'InvalidReportFormat',
  InvalidRequestStructure = 'InvalidRequestStructure',
  InvalidRequestBody = 'InvalidRequestBody',
  InvalidRequestBodyKeys = 'InvalidRequestBodyKeys',
  InvalidRuleId = 'InvalidRuleId',
  InvalidRulesForTool = 'InvalidRulesForTool',
  InvalidScanningFromDate = 'InvalidScanningFromDate',
  InvalidScanningToDate = 'InvalidScanningToDate',
  InvalidScanningType = 'InvalidScanningType',
  InvalidUrl = 'InvalidUrl',
  InvalidUrls = 'InvalidUrls',
  LocaleCreateInvalidRequest = 'LocaleCreateInvalidRequest',
  LogInMissingLogin = 'LogInMissingLogin',
  LogInMissingPassword = 'LogInMissingPassword',
  MalformedScanningURL = 'MalformedScanningURL',
  ManualExcelAuditUploadFailed = 'ManualExcelAuditUploadFailed',
  ManualAuditDuplicatedIssueId = 'ManualAuditDuplicatedIssueId',
  ManualAuditInvalidConformanceTarget = 'ManualAuditInvalidConformanceTarget',
  ManualEvaluationScopeNotFound = 'ManualEvaluationScopeNotFound',
  ManualEvaluationInvalidStatusForConformanceScoreCalculation = 'ManualEvaluationInvalidStatusForConformanceScoreCalculation',
  ManualEvaluationInvalidStatusForAutoVpat = 'ManualEvaluationInvalidStatusForAutoVpat',
  PlatformEvaluationsNotAllowed = 'PlatformEvaluationsNotAllowed',
  ManualAuditInvalidIssueIdType = 'ManualAuditInvalidIssueIdType',
  ManualAuditMissingCustomRule = 'ManualAuditMissingCustomRule',
  ManualAuditMissingFile = 'ManualAuditMissingFile',
  ManualAuditNotFound = 'ManualAuditNotFound',
  ManualAuditIssueNotFound = 'ManualAuditIssueNotFound',
  ManualAuditIssueAttachmentNotFound = 'ManualAuditIssueAttachmentNotFound',
  OnlyManualAuditScansCanBeArchived = 'OnlyManualAuditScansCanBeArchived',
  MissingColumn = 'MissingColumn',
  MissingEmailsInSendEmail = 'MissingEmailsInSendEmail',
  MissingFilesOrTextWithCustomUrls = 'MissingFilesOrTextWithCustomUrls',
  MissingMandatoryValue = 'MissingMandatoryValue',
  MissingScanningJobId = 'MissingScanningJobId',
  MissingScanningURL = 'MissingScanningURL',
  MissingSheet = 'MissingSheet',
  NoAccessRefreshTokenProvided = 'NoAccessRefreshTokenProvided',
  ScimApiTokenRequired = 'ScimApiTokenRequired',
  NoResultForAuditJob = 'NoResultForAuditJob',
  NoteDoesNotExists = 'NoteDoesNotExists',
  NoAccessToDigitalProperty = 'NoAccessToDigitalProperty',
  NoAccessToWorkspace = 'NoAccessToWorkspace',
  ErrorUserHasNoAvailableWorkspaces = 'ErrorUserHasNoAvailableWorkspaces',
  ReportErrorNoAuditDefinition = 'ReportErrorNoAuditDefinition',
  ReportErrorScanAuditNotDefined = 'ReportErrorScanAuditNotDefined',
  ReportErrorReportAuditTypeIsNotDefined = 'ReportErrorReportAuditTypeIsNotDefined',
  RequestInvalidRole = 'RequestInvalidRole',
  RequiredFieldsEmptyOrNull = 'RequiredFieldsEmptyOrNull',
  RequiredFields = 'RequiredFields',
  ResourceDoesNotExists = 'ResourceDoesNotExists',
  RuleIdNotFound = 'RuleIdNotFound',
  RuleNotFound = 'RuleNotFound',
  ScanAuthenticationInvalidPasswordField = 'ScanAuthenticationInvalidPasswordField',
  ScanAuthenticationInvalidSubmitField = 'ScanAuthenticationInvalidSubmitField',
  ScanAuthenticationInvalidUsernameSubmitField = 'ScanAuthenticationInvalidUsernameSubmitField',
  ScanAuthenticationInvalidSuccessField = 'ScanAuthenticationInvalidSuccessField',
  ScanAuthenticationInvalidUsernameField = 'ScanAuthenticationInvalidUsernameField',
  ScanDoesntBelongToRequestedDigitalProperty = 'ScanDoesntBelongToRequestedDigitalProperty',
  ScanJobAborted = 'ScanJobAborted',
  ScanMissingSecureWebAuthenticationData = 'ScanMissingSecureWebAuthenticationData',
  ScanMonthlyScheduleInvalidDay = 'ScanMonthlyScheduleInvalidDay',
  CannotCreateScheduleScanEmptyDates = 'CannotCreateScheduleScanEmptyDates',
  ScanNotFound = 'ScanNotFound',
  ScanOfTypeNotFound = 'ScanOfTypeNotFound',
  AutomatedUserFlowActionFailed = 'AutomatedUserFlowActionFailed',
  ShortLinkNotFound = 'ShortLinkNotFound',
  ScansNotFound = 'ScansNotFound',
  ScanTagMissing = 'ScanTagMissing',
  ScansForMonitoredDigitalPropertyDontExist = 'ScansForMonitoredDigitalPropertyDontExist',
  ScanStopDateMoreThanStartDate = 'ScanStopDateMoreThanStartDate',
  ScanSummariesForMonitoredDigitalPropertyDontExist = 'ScanSummariesForMonitoredDigitalPropertyDontExist',
  ScanSummaryNotFound = 'ScanSummaryNotFound',
  ScanWeeklyScheduleInvalidDay = 'ScanWeeklyScheduleInvalidDay',
  ScanYearlyScheduleInvalidDay = 'ScanYearlyScheduleInvalidDay',
  ScanYearlyScheduleInvalidMonth = 'ScanYearlyScheduleInvalidMonth',
  ServiceUnavailable = 'ServiceUnavailable',
  SignUpMissingLogin = 'SignUpMissingLogin',
  SignUpMissingPassword = 'SignUpMissingPassword',
  TranslationConfigNotFound = 'TranslationConfigNotFound',
  TranslationImportInvalidFile = 'TranslationImportInvalidFile',
  TranslationKeyEmptyOrNull = 'TranslationKeyEmptyOrNull',
  TranslationLangConfigAlreadyExists = 'TranslationLangConfigAlreadyExists',
  TranslationLangConfigNotFound = 'TranslationLangConfigNotFound',
  TranslationRemoveDefaultLanguage = 'TranslationRemoveDefaultLanguage',
  TranslationRemoveLastLanguage = 'TranslationRemoveLastLanguage',
  TranslationValueEmpty = 'TranslationValueEmpty',
  TrainingVideoNotFound = 'TrainingVideoNotFound',
  TrainingVideoDomainNotAllowed = 'TrainingVideoDomainNotAllowed',
  UnexpectedFormatColumns = 'UnexpectedFormatColumns',
  UnableSignupUnauthenticatedUser = 'UnableSignupUnauthenticatedUser',
  UnableToSaveAccessToken = 'UnableToSaveAccessToken',
  UnableToSaveUser = 'UnableToSaveUser',
  UnauthorizedDigitalPropertyId = 'UnauthorizedDigitalPropertyId',
  UnknownError = 'UnknownError',
  UrlsWithRestrictedUrls = 'UrlsWithRestrictedUrls',
  UserAlreadyExists = 'UserAlreadyExists',
  UserAlreadyExistsInWorkspace = 'UserAlreadyExistsInWorkspace',
  UserEmailAlreadyExists = 'UserEmailAlreadyExists',
  UserDisabled = 'UserDisabled',
  UserIdNotDefined = 'UserIdNotDefined',
  UserNotAuthorizedOnWorkspace = 'UserNotAuthorizedOnWorkspace',
  UserNotAuthorized = 'UserNotAuthorized',
  AuthUserDoesNotExist = 'AuthUserDoesNotExist',
  UserRoleNotDefined = 'UserRoleNotDefined',
  ValidationFailed = 'ValidationFailed',
  PageSummaryNotFound = 'PageSummaryNotFound',
  AuditedDocumentNotFoundForPage = 'AuditedDocumentNotFoundForPage',
  JobTitleNotFound = 'JobTitleNotFound',
  UserNotActive = 'UserNotActive',
  UserInvalid = 'UserInvalid',
  AccountDeactivated = 'AccountDeactivated',
  InvalidPasswordPattern = 'InvalidPasswordPattern',
  DigitalPropertyMonitoringInvalidHeader = 'DigitalPropertyMonitoringInvalidHeader',
  DigitalPropertyMonitoringInvalidEndDate = 'DigitalPropertyMonitoringInvalidEndDate',
  DigitalPropertyMonitoringInvalidStartDate = 'DigitalPropertyMonitoringInvalidStartDate',
  RuleAuditHistoryTypeNotSupported = 'RuleAuditHistoryTypeNotSupported',
  DigitalPropertyInvalidPagesLimit = 'DigitalPropertyInvalidPagesLimit',
  TranslationNotFound = 'TranslationNotFound',
  FieldTooLong = 'FieldTooLong',
  FieldTooShort = 'FieldTooShort',
  NoMatchingTaskFound = 'NoMatchingTaskFound',
  TaskStateTransitionNotPossible = 'TaskStateTransitionNotPossible',
  UnauthorizedCommentDeletion = 'UnauthorizedCommentDeletion',
  ErrorCannotGetJiraIssue = 'ErrorCannotGetJiraIssue',
  ErrorFlawNotFound = 'ErrorFlawNotFound',
  ErrorFlawPageNotFound = 'ErrorFlawPageNotFound',
  LogInUserNotFound = 'LogInUserNotFound',
  SignUpInvalidEmail = 'SignUpInvalidEmail',
  LogInUserNotActive = 'LogInUserNotActive',
  SignUpInvalidPassword = 'SignUpInvalidPassword',
  ErrorFlawInvalidUserStatusChange = 'ErrorFlawInvalidUserStatusChange',
  ErrorFlawInvalidDigitalProperty = 'ErrorFlawInvalidDigitalProperty',
  ErrorFlawInvalidScan = 'ErrorFlawInvalidScan',
  ErrorFlawInvalidFinding = 'ErrorFlawInvalidFinding',
  ErrorFlawInvalidDocument = 'ErrorFlawInvalidDocument',
  ErrorFlawAttachTaskInvalidStatus = 'ErrorFlawAttachTaskInvalidStatus',
  ErrorFlawAttachTaskAlreadyLinked = 'ErrorFlawAttachTaskAlreadyLinked',
  ScanMissingBasicAuthData = 'ScanMissingBasicAuthData',
  ErrorManualFindingStatusUpdateDismissedLinkedTaskBadRequest = 'ErrorManualFindingStatusUpdateDismissedLinkedTaskBadRequest',
  ErrorManualFindingStatusUpdateDismissedReasonRequiredBadRequest = 'ErrorManualFindingStatusUpdateDismissedReasonRequiredBadRequest',
  ErrorCreateTaskFromDismissedManualFindingBadRequest = 'ErrorCreateTaskFromDismissedManualFindingBadRequest',
  ErrorCreateTaskWithoutFindings = 'ErrorCreateTaskWithoutFindings',
  ErrorCreateTaskWithDuplicatedFinding = 'ErrorCreateTaskWithDuplicatedFinding',
  ErrorNoScanResultsAvailable = 'ErrorNoScanResultsAvailable',
  AuditRulesInvalidFilter = 'AuditRulesInvalidFilter',
  ActiveScansExceedLimit = 'ActiveScansExceedLimit',
  RequestsCountExceedLimit = 'RequestsCountExceedLimit',
  WorkspaceSettingActiveScansLimit = 'WorkspaceSettingActiveScansLimit',
  NotFound = 'NotFound',
  ErrorCannotDeleteProject = 'ErrorCannotDeleteProject',
  ErrorCannotArchiveProject = 'ErrorCannotArchiveProject',
  MissingAuditToolByNameAndVersion = 'MissingAuditToolByNameAndVersion',
  RescanMaxLimitExceeded = 'RescanMaxLimitExceeded',
  MissingAuditToolForScan = 'MissingAuditToolForScan',
  ErrorReadXLSXFile = 'ErrorReadXLSXFile',
  DigitalPropertyDoesNotBelongToWorkspace = 'DigitalPropertyDoesNotBelongToWorkspace',
  ErrorUnknownSeverity = 'ErrorUnknownSeverity',
  WorkspaceDoesNotBelongToTenant = 'WorkspaceDoesNotBelongToTenant',
  TenantNotFound = 'TenantNotFound',
  NoAccessToManualFindingComment = 'NoAccessToManualFindingComment',
  ManualFindingCommentDoesNotBelongToManualAudit = 'ManualFindingCommentDoesNotBelongToManualAudit',
  NoAccessToTenant = 'NoAccessToTenant',
  NoStaffAccessInSsoTenant = 'NoStaffAccessInSsoTenant',
  InvalidMetricsUpdate = 'InvalidMetricsUpdate',
  ErrorTenantInvalidSubdomain = 'ErrorTenantInvalidSubdomain',
  ErrorTenantDuplicateSubdomain = 'ErrorTenantDuplicateSubdomain',
  UserDoesNotBelongToTenant = 'UserDoesNotBelongToTenant',
  ErrorDuplicateResolvedUrl = 'ErrorDuplicateResolvedUrl',
  ErrorRequestForbiddenInTenantless = 'ErrorRequestForbiddenInTenantless',
  ErrorRequestForbiddenOutsideTenantless = 'ErrorRequestForbiddenOutsideTenantless',
  UrlDoesntBelongToDigitalProperty = 'UrlDoesntBelongToDigitalProperty',
  ErrorInvalidSitemapFormat = 'ErrorInvalidSitemapFormat',
  ErrorInvalidSitemapUrl = 'ErrorInvalidSitemapUrl',
  ErrorActivityLogsDoNotBelongToUserWorkspace = 'ErrorActivityLogsDoNotBelongToUserWorkspace',
  ErrorActivityLogsInaccessibleToUser = 'ErrorActivityLogsInaccessibleToUser',
  ErrorDocumentDigitalPropertyMustBeInWorkspace = 'ErrorDocumentDigitalPropertyMustBeInWorkspace',
  ErrorDocumentDigitalPropertiesShouldNotBeEmpty = 'ErrorDocumentDigitalPropertiesShouldNotBeEmpty',
  ErrorDocumentTitleNotBeEmpty = 'ErrorDocumentTitleNotBeEmpty',
  ErrorDocumentDeliveryDateInvalidFormat = 'ErrorDocumentDeliveryDateInvalidFormat',
  ErrorUrlHasEmptyContentType = 'ErrorUrlHasEmptyContentType',
  ErrorInvalidAdditionalEmails = 'ErrorInvalidAdditionalEmails',
  ErrorInvalidWaitTimeSec = 'ErrorInvalidWaitTimeSec',
  OnlyTenantlessAccess = 'OnlyTenantlessAccess',
  ErrorLoginToTenantlessForbidden = 'ErrorLoginToTenantlessForbidden',
  ErrorLoginToTenantForbidden = 'ErrorLoginToTenantForbidden',
  ErrorCannotAccessFile = 'ErrorCannotAccessFile',
  InternalServerError = 'InternalServerError',
  ExternalAuthUserNotFound = 'ExternalAuthUserNotFound',
  ExternalAuthVerificationError = 'ExternalAuthVerificationError',
  ErrorCannotCreateAsanaConnection = 'ErrorCannotCreateAsanaConnection',
  ErrorCannotCreateAzureConnection = 'ErrorCannotCreateAzureConnection',
  ErrorInvalidAzureConnectionInstance = 'ErrorInvalidAzureConnectionInstance',
  ErrorInvalidAzureConnectionPAT = 'ErrorInvalidAzureConnectionPAT',
  ErrorDuplicateAzureConnection = 'ErrorDuplicateAzureConnection',
  ErrorInvalidAsanaConnectionInstance = 'ErrorInvalidAsanaConnectionInstance',
  ErrorInvalidAsanaConnectionPAT = 'ErrorInvalidAsanaConnectionPAT',
  ErrorDuplicateAsanaConnection = 'ErrorDuplicateAsanaConnection',
  ErrorCannotGetAzureIssueTypes = 'ErrorCannotGetAzureIssueTypes',
  ErrorCannotGetAzureIssueTypeStatuses = 'ErrorCannotGetAzureIssueTypeStatuses',
  ErrorCannotGetAzureIssueStatuses = 'ErrorCannotGetAzureIssueStatuses',
  ErrorInvalidIPAddress = 'ErrorInvalidIPAddress',
  ErrorDuplicateUserFlowTemplateName = 'ErrorDuplicateUserFlowTemplateName',
  ErrorEmptyUserFlowTemplateName = 'ErrorEmptyUserFlowTemplateName',
  ErrorMinimumUserFlowScanPointsRequired = 'ErrorMinimumUserFlowScanPointsRequired',
  ErrorDuplicatePageName = 'ErrorDuplicatePageName',
  ErrorPageScanNullResult = 'ErrorPageScanNullResult',
  ErrorPageScanEmptyDocument = 'ErrorPageScanEmptyDocument',
  PageNotFound = 'PageNotFound',
  PageAlreadyScanned = 'PageAlreadyScanned',
  MobileScreenAlreadyScanned = 'MobileScreenAlreadyScanned',
  PageDoesNotBelongToDigitalProperty = 'PageDoesNotBelongToDigitalProperty',
  NoAccessToPage = 'NoAccessToPage',
  UserFlowTemplateNotFound = 'UserFlowTemplateNotFound',
  NoAccessToUserFlowTemplate = 'NoAccessToUserFlowTemplate',
  UserFlowTemplateDoesNotBelongToDigitalProperty = 'UserFlowTemplateDoesNotBelongToDigitalProperty',
  UserFlowTemplateNotFoundByName = 'UserFlowTemplateNotFoundByName',
  ScannableDocumentNotCorrectStatus = 'ScannableDocumentNotCorrectStatus',
  ScannableDocumentNotFound = 'ScannableDocumentNotFound',
  ScannableDocumentNotScanned = 'ScannableDocumentNotScanned',
  ErrorScannableDocumentRuleNameNotFound = 'ErrorScannableDocumentRuleNameNotFound',
  ErrorScannableDocumentRuleIdNotFound = 'ErrorScannableDocumentRuleIdNotFound',
  ErrorScannableDocumentPageIdNotFound = 'ErrorScannableDocumentPageIdNotFound',
  ErrorInvalidFile = 'ErrorInvalidFile',
  ErrorInvalidDocumentScanResultStatus = 'ErrorInvalidDocumentScanResultStatus',
  ErrorMissingScannableDocumentPage = 'ErrorMissingScannableDocumentPage',
  ErrorInvalidScannableDocumentMetadata = 'ErrorInvalidScannableDocumentMetadata',
  InvalidXML = 'InvalidXML',
  ScreenshotResultsNotFound = 'ScreenshotResultsNotFound',
  UserEmailVerificationTokenInvalid = 'UserEmailVerificationTokenInvalid',
  ProjectDoesNotBelongToWorkspace = 'ProjectDoesNotBelongToWorkspace',
  ProjectInactive = 'ProjectInactive',
  ErrorCannotGetJiraRequiredFields = 'ErrorCannotGetJiraRequiredFields',
  ErrorCannotGetAzureRequiredFields = 'ErrorCannotGetAzureRequiredFields',
  ErrorUnsupportedIssueTrackingIntegrationType = 'ErrorUnsupportedIssueTrackingIntegrationType',
  ErrorInconsistentIssueTrackingStatusMapping = 'ErrorInconsistentIssueTrackingStatusMapping',
  ErrorInvalidStatusMapping = 'ErrorInvalidStatusMapping',
  ErrorCannotGetJiraProjectUsers = 'ErrorCannotGetJiraProjectUsers',
  CrawlPagesRequestNotFound = 'CrawlPagesRequestNotFound',
  ErrorCannotGetJiraLabels = 'ErrorCannotGetJiraLabels',
  ErrorCannotGetJiraTeamSuggestions = 'ErrorCannotGetJiraTeamSuggestions',
  ErrorUploadingFile = 'ErrorUploadingFile',
  ErrorSetIgnoredStatusPermission = 'ErrorSetIgnoredStatusPermission',
  ErrorSetIgnoredStatusUnsupportedSource = 'ErrorSetIgnoredStatusUnsupportedSource',
  UnexpectedResponseFromIssueTracking = 'UnexpectedResponseFromIssueTracking',
  NoAccessToDocument = 'NoAccessToDocument',
  NotImplemented = 'NotImplemented',
  DocumentDoesNotBelongToWorkspace = 'DocumentDoesNotBelongToWorkspace',
  InvalidScanningTypeSourceForPushScan = 'InvalidScanningTypeSourceForPushScan',
  InvalidScanOriginForPushScan = 'InvalidScanOriginForPushScan',
  InvalidMobilePlatformDetailsForPushScan = 'InvalidMobilePlatformDetailsForPushScan',
  RequiredMobilePlatformDetailsForPushScan = 'RequiredMobilePlatformDetailsForPushScan',
  ErrorUnsupportedDocumentScanner = 'ErrorUnsupportedDocumentScanner',
  InvalidScanTagForPushScan = 'InvalidScanTagForPushScan',
  ErrorMethodNotAvailableForJira = 'ErrorMethodNotAvailableForJira',
  ErrorMethodNotAvailableForAsana = 'ErrorMethodNotAvailableForAsana',
  ErrorMethodNotAvailableForAzure = 'ErrorMethodNotAvailableForAzure',
  ErrorMethodNotAvailableForGithub = 'ErrorMethodNotAvailableForGithub',
  ErrorInvalidGithubConnectionInstance = 'ErrorInvalidGithubConnectionInstance',
  ErrorDuplicateGithubConnection = 'ErrorDuplicateGithubConnection',
  ErrorGithubReauthorizationAccountMismatch = 'ErrorGithubReauthorizationAccountMismatch',
  ErrorCannotCreateGithubConnection = 'ErrorCannotCreateGithubConnection',
  ErrorCannotGetGithubAuthorizeUrl = 'ErrorCannotGetGithubAuthorizeUrl',
  ErrorCannotVerifyGithubCode = 'ErrorCannotVerifyGithubCode',
  CannotMigrateWorkspaceWithNoDPToTenant = 'CannotMigrateWorkspaceWithNoDPToTenant',
  ErrorInvalidDesignRuleDataJSON = 'ErrorInvalidDesignRuleDataJSON',
  ErrorInvalidDesignRuleId = 'ErrorInvalidDesignRuleId',
  ErrorInvalidDesignRuleField = 'ErrorInvalidDesignRuleField',
  ErrorScanPagesExceededDownloadLimit = 'ErrorScanPagesExceededDownloadLimit',
  ErrorMatchComponentNameNotUnique = 'ErrorMatchComponentNameNotUnique',
  ErrorMatchComponentCssSelectorNotUnique = 'ErrorMatchComponentCssSelectorNotUnique',
  MatchComponentNotFound = 'MatchComponentNotFound',
  MatchComponentNotFoundByName = 'MatchComponentNotFoundByName',
  FieldNotMatchingRegex = 'FieldNotMatchingRegex',
  FieldMatchingRegex = 'FieldMatchingRegex',
  FieldContainsInvalidCharacters = 'FieldContainsInvalidCharacters',
  FieldMustBeString = 'FieldMustBeString',
  ErrorNumberOfFilesExceedsLimit = 'ErrorNumberOfFilesExceedsLimit',
  ErrorNumberOfNewFilesExceedsLimit = 'ErrorNumberOfNewFilesExceedsLimit',
  InvalidBoundingBox = 'InvalidBoundingBox',
  InvalidIssueType = 'InvalidIssueType',
  InvalidFindingStatus = 'InvalidFindingStatus',
  InvalidScanMetadata = 'InvalidScanMetadata',
  ErrorDesignReviewProjectNotFound = 'ErrorDesignReviewProjectNotFound',
  ErrorDesignReviewProjectNotCompleted = 'ErrorDesignReviewProjectNotCompleted',
  ErrorDesignReviewPageNotFound = 'ErrorDesignReviewPageNotFound',
  ErrorDuplicateDesignPageName = 'ErrorDuplicateDesignPageName',
  ErrorDesignReviewCannotModifyArchivedProject = 'ErrorDesignReviewCannotModifyArchivedProject',
  ErrorDesignReviewCannotModifyCompletedProject = 'ErrorDesignReviewCannotModifyCompletedProject',
  ErrorDesignReviewFindingsReportNotYetGenerated = 'ErrorDesignReviewFindingsReportNotYetGenerated',
  ErrorDesignReviewFindingNotFound = 'ErrorDesignReviewFindingNotFound',
  ErrorDesignReviewFindingCommentNotFound = 'ErrorDesignReviewFindingCommentNotFound',
  ErrorScannedPageDataLightweightOnly = 'ErrorScannedPageDataLightweightOnly',
  ErrorDesignReviewNumberOfFindingsExceedsLimit = 'ErrorDesignReviewNumberOfFindingsExceedsLimit',
  ErrorDesignReviewNoAccessToProject = 'ErrorDesignReviewNoAccessToProject',
  ErrorDesignReviewNoAccessToPage = 'ErrorDesignReviewNoAccessToPage',
  ErrorDesignReviewNoAccessToFinding = 'ErrorDesignReviewNoAccessToFinding',
  ErrorIncorrectOrExpiredMfaToken = 'ErrorIncorrectOrExpiredMfaToken',
  ErrorTooManyIncorrectMfaTokens = 'ErrorTooManyIncorrectMfaTokens',
  ErrorCannotEnableMfaOnTenantWithSso = 'ErrorCannotEnableMfaOnTenantWithSso',
  ErrorMfaAlreadyEnabled = 'ErrorMfaAlreadyEnabled',
  ErrorGenerateMfaSecretForUserFailed = 'ErrorGenerateMfaSecretForUserFailed',
  ErrorVerifyMfaTokenFailed = 'ErrorVerifyMfaTokenFailed',
  ErrorInvalidInputForDecryption = 'ErrorInvalidInputForDecryption',
  EncryptionError = 'EncryptionError',
  DecryptionError = 'DecryptionError',
  PushSaveResultsScanCompleted = 'PushSaveResultsScanCompleted',
  PushShouldHaveCompleteRequestBody = 'PushShouldHaveCompleteRequestBody',
  PushXmlShouldHaveCompleteRequestBody = 'PushXmlShouldHaveCompleteRequestBody',
  ErrorInvalidResourceId = 'ErrorInvalidResourceId',
  FieldBelowMinimum = 'FieldBelowMinimum',
  FieldAboveMaximum = 'FieldAboveMaximum',
  ErrorOnlyOneRemediatedFileUploadAllowed = 'ErrorOnlyOneRemediatedFileUploadAllowed',
  ErrorMaxNumberOfPdfPagesTestedExceeded = 'ErrorMaxNumberOfPdfPagesTestedExceeded',
  ErrorUpdatingPdfPagesTestedCount = 'ErrorUpdatingPdfPagesTestedCount',
  ErrorScannableDocumentAlreadyHasRemediatedDocument = 'ErrorScannableDocumentAlreadyHasRemediatedDocument',
  ErrorScannableDocumentNotAwaitingRemediation = 'ErrorScannableDocumentNotAwaitingRemediation',
  DuplicateScanPointNotAllowed = 'DuplicateScanPointNotAllowed',
  CssSelectorInvalid = 'CssSelectorInvalid',
  SecurityRoleForPackageNotFound = 'SecurityRoleForPackageNotFound',
  ErrorCreateSecurityGroupWithoutName = 'ErrorCreateSecurityGroupWithoutName',
  ErrorCreateSecurityGroupWithoutRoles = 'ErrorCreateSecurityGroupWithoutRoles',
  ErrorCreateSecurityGroupWithoutEntities = 'ErrorCreateSecurityGroupWithoutEntities',
  ErrorCreateFromSecurityGroupTemplatesEntityLevelMismatch = 'ErrorCreateFromSecurityGroupTemplatesEntityLevelMismatch',
  ErrorSecurityGroupNotFound = 'ErrorSecurityGroupNotFound',
  ErrorSecurityGroupTemplateNotFound = 'ErrorSecurityGroupTemplateNotFound',
  ErrorPredefinedSecurityGroupNotFound = 'ErrorPredefinedSecurityGroupNotFound',
  InvalidDesignEvaluationFindingField = 'InvalidDesignEvaluationFindingField',
  ErrorScannableDocumentNumberOfPagesNotFound = 'ErrorScannableDocumentNumberOfPagesNotFound',
  ErrorExcludeUrlOneToOneCorrespondenceNotPresent = 'ErrorExcludeUrlOneToOneCorrespondenceNotPresent',
  InvalidHighlight = 'InvalidHighlight',
  AutomatedUserFlowNotFound = 'AutomatedUserFlowNotFound',
  AutomatedUserFlowNotValid = 'AutomatedUserFlowNotValid',
  AutomatedUserFlowNoScanPoint = 'AutomatedUserFlowNoScanPoint',
  TenantMissingAcademyIntegration = 'TenantMissingAcademyIntegration',
  TenantUserMissingAcademyIntegration = 'TenantUserMissingAcademyIntegration',
  TenantUserMissingAcademyTenantIntegration = 'TenantUserMissingAcademyTenantIntegration',
  AcademyNotFoundError = 'AcademyNotFoundError',
  AcademyAlreadyAssignedToAnotherTenant = 'AcademyAlreadyAssignedToAnotherTenant',
  AcademyWithGivenNameAlreadyExists = 'AcademyWithGivenNameAlreadyExists',
  ErrorDesignReviewHighlightNotFound = 'ErrorDesignReviewHighlightNotFound',
  ErrorDesignReviewNoAccessToHighlight = 'ErrorDesignReviewNoAccessToHighlight',
  DesignReviewFindingRevisionNotMatch = 'DesignReviewFindingRevisionNotMatch',
  ScannableDocumentInvalid = 'ScannableDocumentInvalid',
  DuplicatedDesignRuleId = 'DuplicatedDesignRuleId',
  IncorrectValue = 'IncorrectValue',
  InvalidAMPJSONUpload = 'InvalidAMPJSONUpload',
  PackageNotFound = 'PackageNotFound',
  PackageInstanceNotFound = 'PackageInstanceNotFound',
  TenantAlreadyHasPackageInstance = 'TenantAlreadyHasPackageInstance',
  ThisIsNotAValidImage = 'ThisIsNotAValidImage',
  FieldMustBeUnixTimestamp = 'FieldMustBeUnixTimestamp',
  SalesforceAccountNotFound = 'SalesforceAccountNotFound',
  DuplicateTenantSalesforceAccountId = 'DuplicateTenantSalesforceAccountId',
  FeatureFlagUnauthorized = 'FeatureFlagUnauthorized',
  InvalidStaffSecurityGroupName = 'InvalidStaffSecurityGroupName',
  DigitalPropertyUsageLimitReached = 'DigitalPropertyUsageLimitReached',
  LegacyEaPackageUnavailable = 'LegacyEaPackageUnavailable',
  LegacyEaPackageUnavailableForCreate = 'LegacyEaPackageUnavailableForCreate',
  ScanIdsLengthDifferentFromToolIdsLength = 'ScanIdsLengthDifferentFromToolIdsLength',
  SystemUserNotAllowedForOperation = 'SystemUserNotAllowedForOperation',
  UserEmailDoesNotExistInThePlatform = 'UserEmailDoesNotExistInThePlatform',
  ErrorInvalidWebhookEntities = 'ErrorInvalidWebhookEntities',
  AmpServiceUserNotFound = 'AmpServiceUserNotFound',
  NewPasswordCannotBeUsedAgain = 'NewPasswordCannotBeUsedAgain',
  PasswordIsTooOld = 'PasswordIsTooOld',
  LoginPasswordResetRequired = 'LoginPasswordResetRequired',
  ErrorSendingResetPasswordEmail = 'ErrorSendingResetPasswordEmail',
  ExternalIdExceedsMaximumLength = 'ExternalIdExceedsMaximumLength',
  ExternalIdRequestDuplicate = 'ExternalIdRequestDuplicate',
  ExternalIdAlreadyExists = 'ExternalIdAlreadyExists',
  ZendeskIntegrationError = 'ZendeskIntegrationError',
  MobileAppsIntegrationInternalError = 'MobileAppsIntegrationInternalError',
  MobileAppsIntegrationError = 'MobileAppsIntegrationError',
  MobileAppMetadataReadFailed = 'MobileAppMetadataReadFailed',
  MobileAppBundleIdMismatch = 'MobileAppBundleIdMismatch',
  MobileAppSessionNotFound = 'MobileAppSessionNotFound',
  MobileAppsIntegrationNotConfigured = 'MobileAppsIntegrationNotConfigured',
  MissingScreenshotAltText = 'MissingScreenshotAltText',
  ManualFindingExternalIdNotFound = 'ManualFindingExternalIdNotFound',
  UpdateFindingEmptyFields = 'UpdateFindingEmptyFields',
  StaffGroupsNotFound = 'StaffGroupsNotFound',
  ErrorEnvironmentNameNotUnique = 'ErrorEnvironmentNameNotUnique',
  ErrorEnvironmentURLNotUnique = 'ErrorEnvironmentURLNotUnique',
  ErrorEnvironmentInvalidURLDomain = 'ErrorEnvironmentInvalidURLDomain',
  ExternalIdRequired = 'ExternalIdRequired',
  ErrorContinuumProjectIdInvalid = 'ErrorContinuumProjectIdInvalid',
  FileUploadRequired = 'FileUploadRequired',
  InvalidUpdateEmailsFileFormat = 'InvalidUpdateEmailsFileFormat',
  DuplicateEmailsInUpdateEmailsFile = 'DuplicateEmailsInUpdateEmailsFile',
  UnequalLengthInUpdateEmailsFile = 'UnequalLengthInUpdateEmailsFile',
  EmailInBothTargetAndSourceInUpdateEmailsFile = 'EmailInBothTargetAndSourceInUpdateEmailsFile',
  EmptyUpdateEmailsFile = 'EmptyUpdateEmailsFile',
  MissingScope = 'MissingScope',
  TestGuideNotFound = 'TestGuideNotFound',
  ErrorCannotSendAiChatMessage = 'ErrorCannotSendAiChatMessage',
  ErrorAiChatMessageNotFound = 'ErrorAiChatMessageNotFound',
  AiGatewayTimeout = 'AiGatewayTimeout',
  AiServiceUnavailable = 'AiServiceUnavailable',
  AiRateLimited = 'AiRateLimited',
  AiChatPinLimitReached = 'AiChatPinLimitReached',
  ErrorRunningAiExecutor = 'ErrorRunningAiExecutor',
  AiDataSummaryNotFound = 'AiDataSummaryNotFound',
  ErrorGeneratingAiDataSummary = 'ErrorGeneratingAiDataSummary',
  DigitalPropertyMetricsInvalidScheduledAt = 'DigitalPropertyMetricsInvalidScheduledAt',
  IllegalTestGuideModification = 'IllegalTestGuideModification',
  IllegalAddingTestGuide = 'IllegalAddingTestGuide',
  ErrorMissingIssueId = 'ErrorMissingIssueId',
  ErrorIssueIdAlreadyLinked = 'ErrorIssueIdAlreadyLinked',
  ErrorCannotFindJiraIssue = 'ErrorCannotFindJiraIssue',
  ErrorCannotCreateWorkspaceDefaultDP = 'ErrorCannotCreateWorkspaceDefaultDP',
  ErrorDigitalPropertyDetailsRequired = 'ErrorDigitalPropertyDetailsRequired',
  CloudsmithIntegrationError = 'CloudsmithIntegrationError',
  Odt2PlatformNotFound = 'Odt2PlatformNotFound',
  Odt2UpdateFileNotFound = 'Odt2UpdateFileNotFound',
  ZtFixDownloadNotFound = 'ZtFixDownloadNotFound',
  ErrorIssueProjectMismatch = 'ErrorIssueProjectMismatch',
  ErrorIssueLinkedToOtherProject = 'ErrorIssueLinkedToOtherProject',
  ErrorRuleLibraryForCodeNotFound = 'ErrorRuleLibraryForCodeNotFound',
  ErrorMediumForCodeNotFound = 'ErrorMediumForCodeNotFound',
  InvalidUserRoleId = 'InvalidUserRoleId',
  CustomRuleNotFound = 'CustomRuleNotFound',
  ErrorCustomAuditRuleIdNotUnique = 'ErrorCustomAuditRuleIdNotUnique',
  InvalidWorkbook = 'InvalidWorkbook',
  TaskNotFound = 'TaskNotFound',
  ErrorCannotUpdateJiraWebhook = 'ErrorCannotUpdateJiraWebhook',
  ErrorCannotUpdateGithubIssuesWebhook = 'ErrorCannotUpdateGithubIssuesWebhook',
  ErrorCannotUpdateGitlabIssuesWebhook = 'ErrorCannotUpdateGitlabIssuesWebhook',
  ErrorIssueKeyDuplicated = 'ErrorIssueKeyDuplicated',
  ErrorValidationIssueLinkRequestFields = 'ErrorValidationIssueLinkRequestFields',
  ScimDisabled = 'ScimDisabled',
  NonSSOTenantsCannotUseScim = 'NonSSOTenantsCannotUseScim',
  ErrorCannotGetAsanaConfigurableFields = 'ErrorCannotGetAsanaConfigurableFields',
  ErrorCannotGetAsanaProjectUsers = 'ErrorCannotGetAsanaProjectUsers',
  UserNotScim = 'UserNotScim',
  UserNotUnassignedScim = 'UserNotUnassignedScim',
  ScimPatchOperationValueIsRequired = 'ScimPatchOperationValueIsRequired',
  ScimPatchOperationValueTypeInvalid = 'ScimPatchOperationValueTypeInvalid',
  ManualRequestNotFound = 'ManualRequestNotFound',
  StaffUserCannotBeUpdated = 'StaffUserCannotBeUpdated',
  StaffUserCannotBeRetrieved = 'StaffUserCannotBeRetrieved',
  ErrorFetchingFile = 'ErrorFetchingFile',
  PageEvaluationTimeout = 'PageEvaluationTimeout',
  PackageAddonNotFound = 'PackageAddonNotFound',
  UserWayAPICallError = 'UserWayAPICallError',
  DigitalPropertyMissingUrl = 'DigitalPropertyMissingUrl',
  UserWaySiteMaxExceeded = 'UserWaySiteMaxExceeded',
  UserWayOrganizationNotConfigured = 'UserWayOrganizationNotConfigured',
  ErrorDigitalPropertyNotWebTyped = 'ErrorDigitalPropertyNotWebTyped',
  CannotModifyEvaluation = 'CannotModifyEvaluation',
  UserWayHostNameDuplicated = 'UserWayHostNameDuplicated',
  UserWayUserHasNoAccess = 'UserWayUserHasNoAccess',
  CustomSeveritiesLimitReached = 'CustomSeveritiesLimitReached',
  NotEnoughCustomSeveritiesToUpdateRanks = 'NotEnoughCustomSeveritiesToUpdateRanks',
  ErrorCustomSeverityDoesNotExist = 'ErrorCustomSeverityDoesNotExist',
  DuplicateFieldValue = 'DuplicateFieldValue',
  CannotModifyEvaluationSeverity = 'CannotModifyEvaluationSeverity',
  FileTypeNotAllowed = 'FileTypeNotAllowed',
  FileSizeTooLarge = 'FileSizeTooLarge',
  WorkspaceNotFoundForScan = 'WorkspaceNotFoundForScan',
  MobileAppScanFailed = 'MobileAppScanFailed',
  DigitalPropertyNotMobile = 'DigitalPropertyNotMobile',
  UnknownScanStatus = 'UnknownScanStatus',
  InvalidStatusTransition = 'InvalidStatusTransition',
  ForbiddenInWebDP = 'ForbiddenInWebDP',
  ForbiddenInMobileDP = 'ForbiddenInMobileDP',
  RequiredHeaderEndpoint = 'RequiredHeaderEndpoint',
  ScanningAgentRequiresEncryptionKey = 'ScanningAgentRequiresEncryptionKey',
  ScanningAgentNotInitialized = 'ScanningAgentNotInitialized',
  DigitalPropertyTagLimitExceeded = 'DigitalPropertyTagLimitExceeded',
  DigitalPropertyTagsContainDuplicates = 'DigitalPropertyTagsContainDuplicates',
  InvalidValue = 'InvalidValue',
  ScimPatchOperationOpFieldInvalid = 'ScimPatchOperationOpFieldInvalid',
  ErrorCommonFlawNotFound = 'ErrorCommonFlawNotFound',
  SwaScreenshotError = 'SwaScreenshotError',
  AutomatedUserFlowScreenshotError = 'AutomatedUserFlowScreenshotError',
  AiMonitoringDataSummaryNotFound = 'AiMonitoringDataSummaryNotFound',
  ScanContextMissing = 'ScanContextMissing',
  InvalidWebhookSecret = 'InvalidWebhookSecret',
  InvalidWebhookHeaderName = 'InvalidWebhookHeaderName',
  InvalidWebhookHeaderValue = 'InvalidWebhookHeaderValue',
  FeatureNotEnabled = 'FeatureNotEnabled',
  IllegalStandardModification = 'IllegalStandardModification',
  CannotDeleteInternalComment = 'CannotDeleteInternalComment',
  CannotDeleteFlagComment = 'CannotDeleteFlagComment',
  CannotDeleteOtherUserComment = 'CannotDeleteOtherUserComment',
  CannotEditComment = 'CannotEditComment',
  XmlPageSourceFormatNotSupported = 'XmlPageSourceFormatNotSupported',
  InvalidProgramDashboardAIReport = 'InvalidProgramDashboardAIReport',
  ErrorInvalidAiFiltersPrompt = 'ErrorInvalidAiFiltersPrompt',
  ErrorAiFiltersGenerationFailed = 'ErrorAiFiltersGenerationFailed',
  IssueIntegrationOAuth2RequireCredentials = 'IssueIntegrationOAuth2RequireCredentials',
  IssueIntegrationOAuth2NotSupported = 'IssueIntegrationOAuth2NotSupported',
  IssueIntegrationOAuth2FailedAuthentication = 'IssueIntegrationOAuth2FailedAuthentication',
  NotEnoughDataForCrossServiceRequest = 'NotEnoughDataForCrossServiceRequest',
  TenantAiIsDisabled = 'TenantAiIsDisabled',
  InvalidPrioritizationMethod = 'InvalidPrioritizationMethod',
  InvalidMicroservicesAccessToken = 'InvalidMicroservicesAccessToken',
  InvalidOAuth2State = 'InvalidOAuth2State',
  OAuth2AccessDenied = 'OAuth2AccessDenied',
  RuleLibraryForIdNotFound = 'RuleLibraryForIdNotFound',
  RuleLibraryNotWeb = 'RuleLibraryNotWeb',
  AiTestingDisabled = 'AiTestingDisabled',
  ErrorWorkspaceNotArchived = 'ErrorWorkspaceNotArchived',
  ErrorWorkspaceNotActive = 'ErrorWorkspaceNotActive',
  ErrorWorkspaceRestoreNoSpaceForAssets = 'ErrorWorkspaceRestoreNoSpaceForAssets',
  ErrorWorkspaceAlreadyArchived = 'ErrorWorkspaceAlreadyArchived',
  ScreenshotSkippedDueToPrivacy = 'ScreenshotSkippedDueToPrivacy',
  MobileEngineAppDuplicateIdentifier = 'MobileEngineAppDuplicateIdentifier',
  ForbiddenMobileBundleId = 'ForbiddenMobileBundleId',
  InvalidProjection = 'InvalidProjection',
  AccessibilityTestResultNotFound = 'AccessibilityTestResultNotFound',
  UserWayAccountCodeMismatch = 'UserWayAccountCodeMismatch',
  UnrecognizedDataLevel = 'UnrecognizedDataLevel',
  CustomReportNotFound = 'CustomReportNotFound',
  CustomReportSaveFailed = 'CustomReportSaveFailed',
  CustomReportUpdateFailed = 'CustomReportUpdateFailed',
  CustomReportDeleteFailed = 'CustomReportDeleteFailed',
  CustomReportRegenerateTimeframeUnchanged = 'CustomReportRegenerateTimeframeUnchanged',
  ShareLinkNotFound = 'ShareLinkNotFound',
  ShareReportOrganizationMismatch = 'ShareReportOrganizationMismatch',
  ShareReportDuplicateRecipient = 'ShareReportDuplicateRecipient',
  ShareReportSelfShare = 'ShareReportSelfShare',
  ShareReportRecipientNotFound = 'ShareReportRecipientNotFound',
  ShareReportRecipientLimit = 'ShareReportRecipientLimit',
  CustomReportRecipientNotAdded = 'CustomReportRecipientNotAdded',
  NoAccessToSharedCustomReport = 'NoAccessToSharedCustomReport',
  OutpostDebugLogsNotEnabledForTenant = 'OutpostDebugLogsNotEnabledForTenant',
  OdtIntegrationError = 'OdtIntegrationError',
  AiChatMessageTooLong = 'AiChatMessageTooLong',
  DigitalPropertyTypeMustBeMobileForOdtPackage = 'DigitalPropertyTypeMustBeMobileForOdtPackage',
  MobileScreenDuplicateName = 'MobileScreenDuplicateName',
  ReportingAgentSessionInFlight = 'ReportingAgentSessionInFlight',
  ReportingAgentMessageSaveFailed = 'ReportingAgentMessageSaveFailed',
  ReportingAgentSnapshotSaveFailed = 'ReportingAgentSnapshotSaveFailed',
  ManualFindingFlagReasonRequired = 'ManualFindingFlagReasonRequired',
  ManualFindingFlagReasonInvalid = 'ManualFindingFlagReasonInvalid',
  InvalidMobileCrawlingAgent = 'InvalidMobileCrawlingAgent',
  InvalidScanUrlCount = 'InvalidScanUrlCount',
  ErrorCreatingCustomReportSchedule = 'ErrorCreatingCustomReportSchedule',
  ErrorUpdatingCustomReportSchedule = 'ErrorUpdatingCustomReportSchedule',
  ErrorDeletingCustomReportSchedule = 'ErrorDeletingCustomReportSchedule',
  ErrorCustomReportScheduleNotFound = 'ErrorCustomReportScheduleNotFound',
  ErrorSendingScheduledReportEmail = 'ErrorSendingScheduledReportEmail',
  HarnessFmeAdminApiKeyNotConfigured = 'HarnessFmeAdminApiKeyNotConfigured',
  ErrorBuildingScheduledReportDocx = 'ErrorBuildingScheduledReportDocx',
  ErrorGeneratingScheduledReportDigest = 'ErrorGeneratingScheduledReportDigest',
  ProjectCustomLabelInvalidName = 'ProjectCustomLabelInvalidName',
  ProjectCustomLabelDuplicate = 'ProjectCustomLabelDuplicate',
  ProjectCustomLabelNameTooLong = 'ProjectCustomLabelNameTooLong',
  ProjectCustomLabelInvalidIdentifier = 'ProjectCustomLabelInvalidIdentifier',
  ProjectCustomLabelLimitExceeded = 'ProjectCustomLabelLimitExceeded',
  ManualEvalAiTestingInvalidStatus = 'ManualEvalAiTestingInvalidStatus',
  ManualEvalCannotUpdateProcessingStatus = 'ManualEvalCannotUpdateProcessingStatus',
  ManualEvalCannotTransitionScopingStatus = 'ManualEvalCannotTransitionScopingStatus',
  ManualEvalCannotArchiveScopingStatus = 'ManualEvalCannotArchiveScopingStatus',
  MobileFlawMatchingRequiresMobileSource = 'MobileFlawMatchingRequiresMobileSource',
  MobileFlawMatchingNotEnabledForScan = 'MobileFlawMatchingNotEnabledForScan',
  ManualEvalAiTestingNoPagesInScope = 'ManualEvalAiTestingNoPagesInScope',
  ManualTrackingCustomLabelNotFound = 'ManualTrackingCustomLabelNotFound',
  ManualTrackingExternalLinkTextTooLong = 'ManualTrackingExternalLinkTextTooLong',
  ManualTrackingExternalLinkUrlTooLong = 'ManualTrackingExternalLinkUrlTooLong',
  ManualTrackingExternalLinkInvalidUrl = 'ManualTrackingExternalLinkInvalidUrl',
  ManualTrackingTaskIntegrationConflict = 'ManualTrackingTaskIntegrationConflict',
  ReportingAgentRestoreGenerationInProgress = 'ReportingAgentRestoreGenerationInProgress',
  ReportingAgentRestoreNoEligibleSnapshot = 'ReportingAgentRestoreNoEligibleSnapshot',
  ReportingAgentRestoreDirectionMismatch = 'ReportingAgentRestoreDirectionMismatch',
  ScimGroupAlreadyExists = 'ScimGroupAlreadyExists',
  ScimGroupNotFound = 'ScimGroupNotFound',
  ScimGroupInvalidMembers = 'ScimGroupInvalidMembers',
  ScimGroupMappingNotFound = 'ScimGroupMappingNotFound',
  ScimGroupMappingInvalidTargets = 'ScimGroupMappingInvalidTargets',
  ScimReconciliationFailed = 'ScimReconciliationFailed',
  MobileScreenInvalidName = 'MobileScreenInvalidName',
  ErrorDeletingReportingAgentMessages = 'ErrorDeletingReportingAgentMessages',
  ErrorDeletingCustomReportSnapshots = 'ErrorDeletingCustomReportSnapshots',
  ErrorDeletingAllCustomReportSchedules = 'ErrorDeletingAllCustomReportSchedules',
  ScopingSessionCreateFailed = 'ScopingSessionCreateFailed',
  ScopingSessionEndFailed = 'ScopingSessionEndFailed',
  ScopingResultsFetchFailed = 'ScopingResultsFetchFailed',
  ScopingResultsEmpty = 'ScopingResultsEmpty',
  ScopingCrawlNotFound = 'ScopingCrawlNotFound',
  ScopingCrawlNotSuccessful = 'ScopingCrawlNotSuccessful',
  ErrorDuplicateGitlabConnection = 'ErrorDuplicateGitlabConnection',
  ErrorGitlabReauthorizationAccountMismatch = 'ErrorGitlabReauthorizationAccountMismatch',
  ErrorCannotVerifyGitlabCode = 'ErrorCannotVerifyGitlabCode',
  ErrorMethodNotAvailableForGitlab = 'ErrorMethodNotAvailableForGitlab',
  ErrorCannotGetGitlabIssueTypes = 'ErrorCannotGetGitlabIssueTypes',
  ErrorCannotGetGitlabAuthorizeUrl = 'ErrorCannotGetGitlabAuthorizeUrl',
  ErrorCannotGetGitlabIssueStatuses = 'ErrorCannotGetGitlabIssueStatuses',
  ErrorCannotGetGitlabWidgetDefinitions = 'ErrorCannotGetGitlabWidgetDefinitions',
  ErrorCannotGetGitlabCustomFields = 'ErrorCannotGetGitlabCustomFields',
  ErrorCannotGetGitlabLabels = 'ErrorCannotGetGitlabLabels',
  ErrorCannotGetGitlabMembers = 'ErrorCannotGetGitlabMembers',
  ErrorCannotGetGitlabMilestones = 'ErrorCannotGetGitlabMilestones',
  ErrorCannotSearchKnowledgeBase = 'ErrorCannotSearchKnowledgeBase',
  RemovalBlockedSelfRemoval = 'RemovalBlockedSelfRemoval',
  RemovalBlockedServiceAccount = 'RemovalBlockedServiceAccount',
  RemovalBlockedLastOrgAdmin = 'RemovalBlockedLastOrgAdmin',
  StalePermissionsVersion = 'StalePermissionsVersion',
  LegacyPermissionWriteDisabled = 'LegacyPermissionWriteDisabled',
  ManualEvalScopingCrawlRequiresScopingStatus = 'ManualEvalScopingCrawlRequiresScopingStatus',
  UserListSearchTermTooShort = 'UserListSearchTermTooShort',
  ForcePasswordResetBlockedSelf = 'ForcePasswordResetBlockedSelf',
  ForcePasswordResetBlockedServiceAccount = 'ForcePasswordResetBlockedServiceAccount',
  ForcePasswordResetBlockedInactiveUser = 'ForcePasswordResetBlockedInactiveUser',
  ErrorTaskNotLinkedToIssueTracking = 'ErrorTaskNotLinkedToIssueTracking',
  ErrorTaskNotLinkedToJira = 'ErrorTaskNotLinkedToJira',
  ScopingCrawlInProgress = 'ScopingCrawlInProgress',
  GoldenEvaluationNotCompleted = 'GoldenEvaluationNotCompleted',
  ScopingPagesRequireScopingStatus = 'ScopingPagesRequireScopingStatus',
  ScopingPageUrlNotInCrawl = 'ScopingPageUrlNotInCrawl',
  ScopingRecommendedPagesNotAvailable = 'ScopingRecommendedPagesNotAvailable',
  MobileManualEvaluationNotFound = 'MobileManualEvaluationNotFound',
  MobileManualEvaluationInvalidStatus = 'MobileManualEvaluationInvalidStatus',
  MobileManualEvaluationInvalidRequest = 'MobileManualEvaluationInvalidRequest',
  MobileManualEvaluationScreenshotNotFound = 'MobileManualEvaluationScreenshotNotFound',
  InviteAlreadyAccepted = 'InviteAlreadyAccepted',
  InviteOutsideScope = 'InviteOutsideScope',
  ResendCooldown = 'ResendCooldown',
  ManualEvalAiTestingNotProcessing = 'ManualEvalAiTestingNotProcessing',
}
